<template>
  <div class="monitoring-equipment-container">
    <div class="page-content">
      <div class="operation-bar">
        <el-button type="primary" size="mini" @click="handleCreate"
          >+新增</el-button
        >
        <el-button
          type="danger"
          size="mini"
          @click="handleBatchDelete"
          :disabled="!selectedRows.length"
          >删除</el-button
        >
        <div class="search-box">
          <span style="margin-right: 10px; color: #fff">所属分类</span>
          <el-select
            v-model="classify"
            placeholder="请选择"
            style="width: 200px"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in categoryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span style="margin-right: 10px; color: #fff">所属企业</span>
          <el-select
            v-model="searchTenantId"
            placeholder="请选择"
            style="width: 200px"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in tenantOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span style="margin: 0 10px; color: #fff">所属大棚</span>
          <el-select
            v-model="searchGreenhouseId"
            placeholder="请选择"
            style="width: 200px"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in greenhouseOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            icon="el-icon-search"
            style="margin-left: 10px"
            size="mini"
            type="primary"
            @click="handleSearch"
            >查询</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        height="60vh"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="设备名称"></el-table-column>
        <el-table-column prop="classify" label="所属分类">
          <template slot-scope="scope">
            {{
              categoryOptions.find((item) => item.value == scope.row.classify)
                ?.label
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="greenhouseName"
          label="所属大棚"
        ></el-table-column>
        <el-table-column prop="tenantName" label="所属企业"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="color: #2680dd"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              style="color: #ff4d4f"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 检测设备弹窗组件 -->
    <MonitoringEquipmentDialog
      :visible.sync="dialogVisible"
      :is-edit="isEdit"
      :edit-data="editData"
      @submitted="handleDialogSubmitted"
    />
  </div>
</template>

<script>
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";
import MonitoringEquipmentDialog from "./MonitoringEquipmentDialog.vue";

export default {
  name: "MonitoringEquipment",
  components: {
    MonitoringEquipmentDialog,
  },
  data() {
    return {
      categoryOptions: [
        { label: "土壤PH传感器", value: "1" },
        { label: "土壤氮磷钾传感器", value: "2" },
        { label: "土壤温湿度EC传感器", value: "3" },
        { label: "大气环境监测传感器", value: "4" },
        { label: "棚外气象站", value: "5" },
      ],
      classify: null,
      tableData: [],
      selectedRows: [],
      searchTenantId: "",
      searchGreenhouseId: "",
      page: 1,
      pageSize: 10,
      totalCount: 0,
      dialogVisible: false,
      isEdit: false,
      editData: {},
      tenantOptions: [],
      greenhouseOptions: [],
    };
  },
  created() {
    this.fetchData();
    this.fetchTenantOptions();
    this.fetchGreenhouseOptions();
  },
  methods: {
    // 获取企业列表
    async fetchTenantOptions() {
      const res = await axios.get(baseUrl + "/api/system/users");
      // 过滤出角色为企业的用户
      const agriTechUsers = res.data.filter(
        (user) =>
          user.roleCodes && user.roleCodes.split(",").includes("company_admin")
      );
      this.tenantOptions = agriTechUsers.map((item) => ({
        label: item.nickName,
        value: item.id,
      }));
    },
    // 获取大棚列表
    async fetchGreenhouseOptions() {
      const formData = new FormData();
      formData.append("enableStatus", 1);
      const greenhouseRes = await axios.post(
        baseUrl + "/api/basic/greenhouse/selection",
        formData
      );
      this.greenhouseOptions = greenhouseRes.data.map((item) => ({
        label: item.serialNumber,
        value: item.id,
      }));
    },
    // 获取检测设备列表
    async fetchData() {
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          tenantId: this.searchTenantId,
          greenhouseId: this.searchGreenhouseId,
          classify: this.classify || null,
          deviceType: "MONITORING_DEVICE",
        };
        // 使用检测设备相关的接口，如果接口不同需要调整
        const res = await axios.post(
          baseUrl + "/api/device/device-info/list-page",
          params
        );
        if (res.code === 200) {
          this.tableData = res.data.list || [];
          this.totalCount = parseInt(res.data.totalCount) || 0;
        }
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSearch() {
      this.page = 1;
      this.fetchData();
    },
    handleCreate() {
      this.isEdit = false;
      this.editData = {};
      this.dialogVisible = true;
    },
    async handleEdit(row) {
      try {
        // 调用详情接口获取完整的设备信息
        const res = await axios.post(
          baseUrl + "/api/device/device-info/detail-by-id",
          {
            id: row.id,
          }
        );
        if (res.code === 200 && res.data) {
          this.isEdit = true;
          this.editData = { ...row, ...res.data };
          this.dialogVisible = true;
        }
      } catch (error) {
        console.error("获取设备详情失败:", error);
        this.$message.error("获取设备详情失败");
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm(`确认删除设备 "${row.name}" 吗？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        const res = await axios.post(
          baseUrl + "/api/device/device-info/delete-batch",
          [row.id]
        );
        if (res.code === 200) {
          this.$message.success("删除成功");
          this.fetchData();
        }
      } catch (error) {
        if (error !== "cancel") {
          console.error("删除失败:", error);
        }
      }
    },
    // 弹窗提交处理
    handleDialogSubmitted() {
      this.fetchData();
    },
    async handleBatchDelete() {
      if (!this.selectedRows.length) return;
      try {
        await this.$confirm(
          `确认删除选中的 ${this.selectedRows.length} 个设备吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
        const ids = this.selectedRows.map((row) => row.id);
        const res = await axios.post(
          baseUrl + "/api/device/device-info/delete-batch",
          ids
        );
        if (res.code === 200) {
          this.$message.success("删除成功");
          this.fetchData();
        }
      } catch (error) {
        if (error !== "cancel") {
          console.error("删除失败:", error);
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
  },
};
</script>

<style scoped lang="less">
.monitoring-equipment-container {
  .page-content {
    background: rgba(0, 11, 47, 0.3);
    padding: 20px;
    border-radius: 4px;

    .operation-bar {
      margin-bottom: 20px;
      display: flex;
      align-items: center;

      .search-box {
        margin-left: auto;
        display: flex;
        align-items: center;
      }
    }

    .pagination-container {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
